import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/gym/$venueUuid/challenges/$challengeUuid/profile/")({
  loader: () => {
    throw redirect({
      to: "./details",
      from: "/gym/$venueUuid/challenges/$challengeUuid/profile/",
    });
  },
});
